module.exports = __webpack_public_path__ + "media/images/illust/illust-g30s-b88f53a3fc5920ee4bf64d7368556dba.svg";